import { mapState, mapActions, mapGetters } from 'vuex'
import { KeybeIconType } from '@/shared/infrastructure/enums/icons/KeybeIconType'
import KeybeIcon from '@/shared/infrastructure/ui/icons/KeybeIcon.vue'
import UserImageUpload from '../UserImageUpload/UserImageUpload.vue'
import { UserStates } from '@/components/conversations/enums/UserStates'
import AdvisersRepository from '@/modules/conversations/infrastructure/http/Advisers.repository'
import AdvisorSwitch from '@/shared/infrastructure/ui/layout/AdvisorSwitch.vue'
import UserAppsList from '../UserAppsList/UserAppsList.vue'
import Colors from '@/utils/Colors'
import KeybeButton from '@/modules/DesignSystem/infrastructure/components/KeybeButton/KeybeButton.vue'
import PushNotificationsController from '@/controllers/PushNotificationsController'
import AuthService from '@/services/AuthService'
import AdviserStatusController from '@/modules/conversations/infrastructure/controllers/AdviserStatus.controller'
import ButtonComissions from './ButtonComissions/ButtonComissions.vue'
import { EventBus } from '@/eventBus'
export default {
  props: {
  },
  components: {
    UserImageUpload,
    AdvisorSwitch,
    UserAppsList,
    KeybeButton,
    KeybeIcon,
    ButtonComissions
  },
  computed: {
    ...mapState('UserStore', ['user']),
    ...mapGetters('UserStore', ['isAgent']),
    ...mapState('AppStore', ['selectedApp']),
    userName (): string {
      return this.user?.name + ' ' + this.user?.lastName
    },
    appName (): string {
      return this.selectedApp?.name || ''
    },
    isUserOnline (): boolean {
      return this.adviserStatus === UserStates.Online
    }
  },
  mounted () {
    this.getAdviserStatus()
  },
  data () {
    return {
      Colors,
      adviserStatus: UserStates.Offline,
      KeybeIconType,
      showModal: false
    }
  },
  methods: {
    ...mapActions('LayoutStore', ['setListBoxWidth']),
    ...mapActions('UserStore', ['logout']),
    getAdviserStatus (): void {
      this.adviserStatus = AdvisersRepository.getAdviserStatus(this.user.userId)
    },
    async _logout (): Promise<void> {
      await PushNotificationsController.setOneSignalStatus({ active: false })
      await AdviserStatusController.inactiveIfIsAdviser(this.isAgent)
      await AuthService.logout()
      this.setListBoxWidth(null)
      this.logout()
      window.location.href = `${process.env.VUE_APP_BASE_KEYBE_URL}/signin`
    },
    viewModal (): void {
      EventBus.$emit('openCommissionsModal')
    },
    closeModal (): void {
      this.showModal = false
    }
  }
}
